<style scoped>
  .pop-doc-page {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #FFF;
    border-radius: 8px;
    z-index: 9;
  }
</style>

<template>
  <div>
    <span @click="status.print = true">打开</span>
    <div v-if="status.print" class="pop-doc-page">
      <print @quit="status.print = false" :sources="sources" />
    </div>
  </div>
</template>

<script>
import Print from '@/components/base/file/print.vue'

export default {
  components: { Print },
  data () {
    return {
      status: {
        print: false
      },
      sources: [
        {
          direction: 'row', // 横向排列 仅支持指定宽度
          justifyContent: 'space-around',
          sources: [
            { src: '/static/test/1.jpg', width: '20%' },
            { src: '/static/test/1.jpg', width: '10cm' },
            { src: '/static/test/1.jpg', width: '70px' },
            { src: '/static/test/1.jpg', width: 100 }
          ]
        },
        '/static/test/3.jpg',
        {
          sources: [
            '/static/test/4.jpg',    
            '/static/test/4.jpg'
          ]
        },
        '/static/test/3.jpg',
        '/static/test/3.jpg',
        '/static/test/5.jpg',
        {
          direction: 'column', // 纵向拍了 仅支持指定高度
          sources: [
            { src: '/static/test/2.jpg', height: '21%' },
            { src: '/static/test/2.jpg', height: '12cm' },
            { src: '/static/test/2.jpg', height: '73px' },
            { src: '/static/test/2.jpg', height: 104 }
          ]
        },
        '/static/test/5.jpg'
      ]
      // source: [
      //   '/static/test/1.jpg',
      //   '/static/test/2.jpg',
      //   '/static/test/3.jpg',
      //   '/static/test/4.jpg',
      //   '/static/test/5.jpg'
      // ]
    }
  }
}
</script>
